/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:inline-block}[_nghost-%COMP%]   .user[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:600;font-size:18px;float:right;margin:3px 0 0 8px}[_nghost-%COMP%]   .user[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{width:30px;height:30px}"];
export { styles as styles };
